(function($, undefined) {

	'use strict';
    var createProfileBtn;
    var previewProfileBtn;
    var selectTypeProfile;
    var autocomplete;
    var friendlyUrlInput;
    var defaultBanner;
    var boxThemeInfoBtn;
    var boxThemeSaveIconBtn;
    var boxThemeIcon;
    var addressInput;
    var cityInput;
    var cpInput;
    var provInput;
    var countryInput;
    var deleteProfilePicBtn;
    var profileNameInput;
    
    var checkForm = function(event){
        event.preventDefault();
        
        var createForm = $(".create-profile-form");
        formValidator.validateForm(createForm);
        
        if (!createForm.hasClass('has-error')) {
            createProfileBtn.addClass('disabled');
            createForm.submit();
        }
    };    
    
    var toggleItems = function(){
        var t = $(this);
        var val = t.val();
        
        /* If room - display extra fields */
        if(val === '2'){
            $(".activate-room").slideDown();
            $(".activate-room").find("input").addClass("required");
            $(".hide-room").slideUp();
            activateGlgAutocomplete();
            setTimeout(function() {
                addressInput.removeAttr("placeholder");
            }, 100);
        }
        else{            
            $(".activate-room").slideUp();
            $(".hide-room").slideDown();
            $(".activate-room").find("input").removeClass("required");
        }
    };
    
    var activateGlgAutocomplete = function(){
        var request = {
//			componentRestrictions: {country: 'ca'}
		};

        // Using getAddressInput() instead of addressInput directly fixes a 
        // potential race condition where an external script would use
        // this method before init was called by the header.
        autocomplete = new google.maps.places.Autocomplete(getAddressInput()[0], request);
        
        google.maps.event.addListener(autocomplete, 'place_changed', function () {
            addressSearch();
        });
    };
    
    var addressSearch = function(addr) {
		var coorUrl = (addr !== undefined) ? addr : addressInput.val();
		var geocoder = new google.maps.Geocoder();
        var cp,street,city, province, country;

		geocoder.geocode({'address': coorUrl}, function(results, status) {
            var strNbr = "";
            for (var i = 0; i < results[0].address_components.length; i++) {
                var component = results[0].address_components[i];
                if (component.types[0] === "postal_code")
                {
                    cp = component.short_name;
                }
                if (component.types[0] === "street_number")
                {
                    strNbr = component.short_name;
                }
                if (component.types[0] === "locality" || (!city && component.types[0] === "administrative_area_level_3"))
                {
                    city = component.short_name;
                }
                if (component.types[0] === "administrative_area_level_1")
                {
                    province = component.short_name;
                }
                if (component.types[0] === "country")
                {
                    country = component.short_name;
                }
                if (component.types[0] === "route")
                {
                    street = component.short_name;
                }
            }
            street = strNbr + " " + street;
            
            if ( street === ' undefined' ) {
                street = '-';
            }
            
            if (cp === '') {
                geocoder.geocode({'location': results[0].geometry.location}, function(results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        for (var i = 0; i < results[0].address_components.length; ++i) {
                            var component = results[0].address_components[i];
                            if (component.types[0] === "postal_code") {
                                cp = component.long_name;
                            }
                            if (component.types[0] === "street_number")
                            {
                                strNbr = component.short_name;
                            }
                            if (component.types[0] === "locality" || (!city && component.types[0] === "administrative_area_level_3"))
                            {
                                city = component.short_name;
                            }
                            if (component.types[0] === "administrative_area_level_1")
                            {
                                province = component.short_name;
                            }
                            if (component.types[0] === "country")
                            {
                                country = component.short_name;
                            }
                            if (component.types[0] === "route")
                            {
                                street = component.short_name;
                            }
                        }
                        street = strNbr + " " + street;
                        var placeLat = results[0].geometry.location.lat();
                        var placeLng = results[0].geometry.location.lng();

                        $("input[name=lat]").val(placeLat);
                        $("input[name=hiddenLat]").val(placeLat);
                        $("input[name=lng]").val(placeLng);
                        $("input[name=hiddenLng]").val(placeLng);
                        addressInput.val(street);
                        checkVal(addressInput);
                        cityInput.val(city);
                        checkVal(cityInput);
                        cpInput.val(cp);
                        checkVal(cpInput);
                        provInput.val(province);
                        checkVal(provInput);
                        countryInput.val(country);
                        checkVal(countryInput);
                        
                        createMap(placeLat, placeLng);
                        
                        $(".activate-room .input-ctn").each(function() {
                            if ($(this).find("input").length !== 0 && $(this).find("input").val() !== '') {
                                $(this).addClass("focused");
                            }
                        });
                        
                    } 
                });
            }
            else if (cp !== '' && cp !== undefined) {
                if (status === google.maps.GeocoderStatus.OK) {
                    var placeLat = results[0].geometry.location.lat();
                    var placeLng = results[0].geometry.location.lng();
                    
                    $("input[name=lat]").val(placeLat);
                    $("input[name=hiddenLat]").val(placeLat);
                    $("input[name=lng]").val(placeLng);
                    $("input[name=hiddenLng]").val(placeLng);
                    addressInput.val(street);
                    checkVal(addressInput);
                    cityInput.val(city);
                    checkVal(cityInput);
                    // this if doesn't replace the postal code if you search another location.
                    // if (cpInput.val() === '') { // otherwise google cuts some of the provided postal codes
                        cpInput.val(cp);
                        checkVal(cpInput);
                    // }
                    provInput.val(province);
                    checkVal(provInput);
                    countryInput.val(country);
                    checkVal(countryInput);

                    createMap(placeLat, placeLng);
                    
                    $(".activate-room .input-ctn").each(function() {
                        if ($(this).find("input").length !== 0 && $(this).find("input").val() !== '') {
                            $(this).addClass("focused");
                        }
                    });

                } 
            }
		});
	};
    var checkVal = function(input) {
        input.val().length > 0 ? input.removeClass('error').closest('.input-ctn').addClass('focused') : input.closest('.input-ctn').removeClass('focused');
    };
    var createMap = function(lat, lng){
        if ($('#map-ctn').length > 0) {   
            var myLatlng = new google.maps.LatLng(lat, lng);
            var mapOptions = {
                zoom: 18,
                center: myLatlng,
                scrollwheel: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            
            var map = new google.maps.Map(document.getElementById('map-ctn'), mapOptions);
            // document.getElementById('map-ctn').className = "activated";
            $('#map-ctn').addClass('activated');

            var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
                title: name,
                icon: '/static/assets/img/pin.png'
            });
        }
    };
    
    var checkValidFriendlyUrl = function(){
        var t = $(this);
        var val = t.val().trim();
        if(val === '') {
            t.parent().removeClass("error-friendlyUrl");
            t.parent().removeClass("success-friendlyUrl");
        } else {
            val = encodeURIComponent(val);
            t.val(val);
            ajax('/action/epProfiles?friendlyUrl='+val, function(response){
                if(response.indexOf("success") !== -1){
                    t.parent().addClass("success-friendlyUrl");
                    t.parent().removeClass("error-friendlyUrl");     
                }
                else{
                    t.parent().addClass("error-friendlyUrl");                
                    t.parent().removeClass("success-friendlyUrl");                
                }
            },true);
        }
    };
    
    var updateFileInput = function(){
        var file = $(".banner-pic");
        var placeholder = file.parent().find("input.form-input");
        var customBannerImgCtn = $('.edit-profile-img-ctn-banner').closest('.edit-profile-img');
        
        placeholder.val("");
        placeholder.removeClass("required");
        customBannerImgCtn.slideUp(300, function() {
            $(this).remove();
        });
        file.parent().removeClass("focused");
        file.wrap('<form>').closest('form').get(0).reset();
        file.unwrap();
    };
    
    var checkAddress = function(){
        var street = addressInput.val();
        var city = cityInput.val();
        var cp = cpInput.val();
        var province = provInput.val();
        var country = countryInput.val();

        if(street !== '' && street !== undefined){
            addressSearch(street+" "+city+" "+cp+" "+province+" "+country);
        }
    };
    
    var createForm = function(e){
        $("input[name=preview]").val("false");
        $("input[name=pageSuccess]").val($(this).parent().attr("data-create-page")); 
        $(".create-profile-form").removeAttr("target");
        checkForm(e);  
    };
    
    
    var previewForm = function(e){
        $("input[name=preview]").val("true");
        $("input[name=pageSuccess]").val($(this).parent().attr("data-preview-page"));
        $(".create-profile-form").attr("target","_blank");
        $(".create-profile-form").submit();
    };

    var toggleBoxThemeInfoSettings = function() {
        var t = $(this);
        var parentBoxHeader = t.closest('.box-theme-info-settings-outer-ctn');
        var boxSettings = parentBoxHeader.find('.box-theme-info-settings-ctn');

        if (parentBoxHeader.hasClass('open')) {
            boxSettings.slideUp(300);
            parentBoxHeader.removeClass('open');
        } else {
            boxSettings.slideDown(300);
            parentBoxHeader.addClass('open');
        }
    };

    var saveBoxThemeInfoIcon = function() {
        var t = $(this);
        var parentBox = t.closest('.box-theme-info-settings-ctn');
        var checkedRadio = parentBox.find('input[type="radio"]:checked');
        var iconChoiceError = parentBox.find('.box-theme-info-error');
        var iconChoiceSuccess = parentBox.find('.box-theme-info-success');

        iconChoiceError.slideUp(300);
        iconChoiceSuccess.slideUp(300);

        if (checkedRadio.length > 0) {
            var iconChoice = checkedRadio.val();
            var iconId = checkedRadio.attr('id');

            labels.save(iconId, iconChoice, 'fr', function() {
                labels.save(iconId, iconChoice, 'en', function() {
                    iconChoiceSuccess.slideDown(300);
                    setTimeout(function() {
                        iconChoiceSuccess.slideUp(300);
                    }, 5000);
                });
            });

        } else {
            iconChoiceError.slideDown(300);
            setTimeout(function() {
                iconChoiceError.slideUp(300);
            }, 5000);
        }
    };

    var toggleShowBoxInfo = function() {
        var boxInfo =  $(this).closest('.box-theme-info-ctn').find('.tooltip-ctn');

        if (boxInfo.hasClass('open')) {
            boxInfo.removeClass('open');
        } else {
            boxInfo.addClass('open');
        }
    };

    var deleteProfilePic = function() {
        var t = $(this);

        t.closest('.edit-profile-img').slideUp(300, function() {
            $(this).remove();
        });

        t.closest('.box-theme-content').append('<input type="hidden" name="delProfilePic" value="true"/>');
    };

    var updateFriendlyUrl = function() {
        var t = $(this);
        var string = t.val();
        
        string = string.trim();
        string = string.toLowerCase();
        string = string.replace(new RegExp("['`^¸:;.,¨!/$%?&*(){}\"]", "g"), "");
        string = string.replace(new RegExp(" ", "g"), "-");
        string = string.replace(new RegExp("(\\-)\\1+", "g"), "-");
        string = string.replace(new RegExp("[àâä]", "g"), "a");
        string = string.replace(new RegExp("[èêéë]", "g"), "e");
        string = string.replace(new RegExp("ç", "g"), "c");
        string = string.replace(new RegExp("[îï]", "g"), "i");
        string = string.replace(new RegExp("[òô]", "g"), "o");
        string = string.replace(new RegExp("û", "g"), "u");
        string = string.replace(new RegExp("œ", "g"), "oe");
        string = string.replace(new RegExp("æ", "g"), "ae");

        friendlyUrlInput.val(string).trigger('change');
    };

    var getAddressInput = function() {
        if (typeof addressInput !== 'undefined') addressInput;
        
        addressInput = $("input[name=address]").length !== 0 ? $("input[name=address]") : $("input[name=locationAddress]");
        if ($("input[name=address]").length === 0 && $("input[name=locationAddress]").length === 0) {
            addressInput = $("input[name=geolocalisation]");
        }

        return addressInput;
    }

	var init = function () {
        loadTouchEvents($);
        
        createProfileBtn = $(".create-profile-form .create-profile-btn");
        createProfileBtn.on("click",createForm);
        
        previewProfileBtn = $(".preview-profile-btn");
        previewProfileBtn.on("click",previewForm);
        
        selectTypeProfile = $(".profile-type-select");
        selectTypeProfile.on("change", toggleItems);

        getAddressInput();

        cityInput = $("input[name=city]").length !== 0 ? $("input[name=city]") : $("input[name=locationCity]");
        cpInput = $("input[name=postalCode]").length !== 0 ? $("input[name=postalCode]") : $("input[name=locationPC]");
        provInput = $("input[name=province]").length !== 0 ? $("input[name=province]") : $("input[name=locationProvince]");
        countryInput = $("input[name=country]").length !== 0 ? $("input[name=country]") : $("input[name=locationCountry]");
        
        friendlyUrlInput = $("input[name=friendlyUrl]");
        friendlyUrlInput.on("change", checkValidFriendlyUrl);
        
        defaultBanner = $(".default-images-ctn .form-checkbox-ctn");
        defaultBanner.on("click", updateFileInput);

        boxThemeInfoBtn = $('.add-box-theme-info-btn');
        boxThemeInfoBtn.click(toggleBoxThemeInfoSettings);
        boxThemeSaveIconBtn = $('.save-box-theme-icon-btn');
        boxThemeSaveIconBtn.click(saveBoxThemeInfoIcon);
        boxThemeIcon = $('.box-theme-info-icon');
        boxThemeIcon.tap(toggleShowBoxInfo);

        deleteProfilePicBtn = $('.delete-profile-pic-btn');
        deleteProfilePicBtn.click(deleteProfilePic);

        profileNameInput = $('.profile-name');
        profileNameInput.keyup(updateFriendlyUrl);

        // checkAddress on init only for the profile page, profile form pages and event details page
        // add condition here to check more pages
        if ($('body').find('.create-profile-form').length !== 0 || $('body').find('.event-details-description-section').length !== 0 || $('body').find('.profile-page-description-tab-ctn').length !== 0) {
            checkAddress();
        }
        formValidator.init();
	};


	var profile = Fw.component.export('profile', {
		init: init,
        activateGlgAutocomplete : activateGlgAutocomplete,
        checkAddress : checkAddress
	});

})(jQuery);